<template>
  <div>
    <div class="columns is-vcentered is-gapless is-border-bottom has-bg-light is-min-height-50">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns">
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="panel = 'promoteurAccess'" :class="{'is-active': panel === 'promoteurAccess'}" v-if="isDistributeurMode">
            <span class="has-text-weight-normal">
              {{promoteurAccesses.length}} Mandat<span v-if="promoteurAccesses.length > 1">s</span> promoteur<span v-if="promoteurAccesses.length > 1">s</span>
            </span>
          </a>
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="panel = 'programAccess'" :class="{'is-active': panel === 'programAccess'}">
            <span class="has-text-weight-normal">
              {{programAccesses.length}} Mandat<span v-if="programAccesses.length > 1">s</span> programme<span v-if="programAccesses.length > 1">s</span>
            </span>
          </a>
        </div>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a @click="reloadAccess" class="button is-min-width-0 is-radiusless is-small is-light is-min-height-full has-text-grey">
          <span class="icon is-size-6 has-text-grey"><i class="fas fa-sync"></i></span>
        </a>
      </div>
    </div>
    <div v-if="panel === 'promoteurAccess' && !loading">
      <table class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom is-border-bottom"
             v-if="promoteursWrappers && promoteursWrappers.length">
        <thead>
          <tr class="is-size-6">
            <th></th>
            <th>Promoteur</th>
            <th>Mandat</th>
            <th v-if="displayRemuneration"><span>Rémunération</span></th>
          </tr>
        </thead>
        <promoteur-access-item v-for="(access, i) in promoteursWrappers"
                     class="is-size-5 has-text-text"
                     first-key="promoteur"
                     :key="i"
                     :promoteur="access.promoteur"
                     :source="access"
                     :selected-access="selectedAccess"
                     :loading-access="loadingAccess"
                     @addAccess="addAccess"
                     @deleteAccess="deletePromoteurAccess"
                     @updateAccess="updateAccess"
                     @selectedAccess="val => selectedAccess = val">
        </promoteur-access-item>
      </table>
    </div>
    <div v-if="panel === 'programAccess' && !loading">
      <div class="columns is-vcentered is-gapless is-border-bottom has-bg-light">
        <div class="column">
          <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns">
            <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
                @click="programPanel = 'programOpenAccess'" :class="{'is-active': programPanel === 'programOpenAccess'}" v-if="isDistributeurMode">
              <span class="has-text-weight-normal">
                Mandat<span v-if="programAccesses.length > 1">s</span> ouvert<span v-if="programAccesses.length > 1">s</span>
              </span>
            </a>
            <a v-if="!isSectorManager" class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
                @click="programPanel = 'programCreateAccess'" :class="{'is-active': programPanel === 'programCreateAccess'}">
              <span class="has-text-weight-normal">
                Création mandat programme
              </span>
            </a>
          </div>
        </div>
      </div>
      <table class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom is-border-bottom is-border-top"
             v-if="programPanel === 'programOpenAccess' && programAccesses && programAccesses.length">
        <thead>
          <tr class="is-size-6">
            <th></th>
            <th>Programme</th>
            <th>Date de début</th>
            <th>Date de fin</th>
            <th></th>
            <th v-if="displayRemuneration">Rémunération</th>
          </tr>
        </thead>
        <program-access-item v-for="(access, i) in programAccesses"
                     class="is-size-5 has-text-text"
                     first-key="program"
                     :key="i"
                     :company="companyPk"
                     :program="access.program"
                     :source="access"
                     :selected-access="selectedAccess"
                     :loading-access="loadingAccess"
                     @deleteAccess="deleteAccess"
                     @updateAccess="submitUpdateAccess"
                     @selectedAccess="val => selectedAccess = val">
        </program-access-item>
      </table>
      <div v-else-if="programPanel === 'programOpenAccess' && programAccesses" class="column is-12 is-padding-small is-border-top">
        <span class="is-size-6">Aucun mandat programme ouvert</span>
      </div>
      <div v-if="programPanel === 'programCreateAccess'">
        <access-form @submit="createAccess" :loading="loading" ref="accessForm"
                    :source-company="company" :ignored-programs="ignoredPrograms"></access-form>
        <div class="column is-12 is-marginless is-paddingless is-border-top columns">
          <div class="column is-6">
            <a @click="programPanel = 'programOpenAccess'" class="button is-white is-uppercase is-fullwidth">
              <span>Annuler</span>
            </a>
          </div>
          <div class="column is-6">
            <button @click="askSubmit" class="button is-success is-uppercase is-fullwidth has-text-white"
                    :disabled="loading" :class="{'is-loading':loading}">
              <span v-if="!loading">Enregistrer</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { differenceBy } from 'lodash'
  import { GenericList, MultiSelection } from '../../../mixins'
  import { mapGetters, mapState } from 'vuex'
  import ProgramAccessItem from '../../program/Tabs/ProgramAccessItem.vue'
  import PromoteurAccessItem from '../../promoteur/PromoteurAccessItem.vue'
  import AccessForm from '../../access/AccessForm'
  import { bus, EVENTS } from '@/services/bus/index.js'

  export default {
    name: 'CompanyAccessPanel',
    mixins: [ GenericList, MultiSelection ],
    props: {
      company: {
        required: true,
        type: Object
      }
    },
    components: {
      ProgramAccessItem,
      PromoteurAccessItem,
      AccessForm
    },
    data () {
      return {
        selectedAccess: null,
        loading: true,
        loadingAccess: false,
        panel: 'promoteurAccess',
        programPanel: 'programOpenAccess',
        programAccessTotalCount: null,
        programAccesses: [],
        programPagination: {
          page: null,
          pages: null
        },
        promoteurs: [],
        promoteurAccessTotalCount: null,
        promoteurAccesses: [],
        promoteurPagination: {
          page: null,
          pages: null
        },
        service: this.$api.accessService
      }
    },
    computed: {
      ...mapState({
        promoteursList: 'promoteurs'
      }),
      ...mapGetters(['isAdmin', 'isManager', 'isSectorManager', 'currentUserPk', 'displayRemuneration', 'isDistributeurMode']),
      companyPk () {
        return this.company.pk
      },
      pagination () {
        if (this.panel === 'programAccess') return this.programPagination
        else return this.promoteurPagination
      },
      ignoredPrograms () {
        return this.programAccesses.map(x => x.program)
      },
      promoteursWrappers () {
        let wrappers = []
        this.loading = true
        this.promoteurs.forEach((promoteur, i) => {
          let wrapper = {
            pk: 'promoteur' + i,
            promoteur: promoteur.pk,
            promoteur_name: promoteur.name,
            remuneration: null,
            no_access: true
          }

          let access = this.promoteurAccesses.find(x => {
            return x.promoteur === promoteur.pk
          })

          if (access) {
            wrapper.pk = access.pk
            wrapper.no_access = false
            if (access.remuneration) {
              wrapper.remuneration = access.remuneration
            }
          }
          wrappers.push(wrapper)
        })
        this.loading = false
        return wrappers
      }
    },
    methods: {
      async getProgramAccesses (init = false, page = 1) {
        this.loading = true
        let query = {
          company: this.companyPk,
          per_page: 100,
          page,
          sort: 'program_name:asc'
        }
        const r = await this.$api.accessService.get(query)
        if (init) {
          this.programAccesses = []
        }
        this.programAccesses = this.programAccesses.concat(r.data.items)
        this.programAccessTotalCount = r.data.total
        this.programPagination.page = r.data.page
        this.programPagination.pages = r.data.pages
        if (r.data.pages > r.data.page) {
          await this.getProgramAccesses(false, r.data.page + 1)
        } else this.loading = false
      },
      // async getPromoteurs (init = false, page = 1) {
      //   this.loading = true
      //   let params = {page, per_page: 100}
      //   let res = await this.$api.promoteurService.get(params)
      //   if (init) {
      //     this.promoteurs = []
      //   }
      //   this.promoteurs = this.promoteurs.concat(res.data.items)
      //   if (res.data.pages > res.data.page) {
      //     await this.getPromoteurs(false, res.data.page + 1)
      //   } else this.loading = false
      // },
      async getPromoteurAccesses (init = false, page = 1) {
        this.loading = true
        let query = {
          company: this.companyPk,
          per_page: 100,
          page,
          sort: 'promoteur_name:asc'
        }
        const r = await this.$api.accessService.getPromoteurAccess(query)
        if (init) {
          this.promoteurAccesses = []
        }
        this.promoteurAccesses = this.promoteurAccesses.concat(r.data.items)
        this.promoteurAccessTotalCount = r.data.total
        this.promoteurPagination.page = r.data.page
        this.promoteurPagination.pages = r.data.pages
        if (r.data.pages > r.data.page) {
          await this.getPromoteurAccesses(false, r.data.page + 1)
        } else this.loading = false
      },
      async submitUpdateAccess (access) {
        this.loadingAccess = true
        if (access.newAllotments) {
          let toCreate = differenceBy(access.newAllotments, access.allotments, x => x.lot || x.pk)
          let toDelete = differenceBy(access.allotments, access.newAllotments, x => x.lot || x.pk)
          if (toCreate && toCreate.length) await this.createAllotments(access, toCreate)
          if (toDelete && toDelete.length) await this.deleteAllotments(toDelete)
        }
        console.log(access)
        this.updateAccess(access)
      },
      async createAllotments (access, accesses) {
        let data = {
          access: access.pk,
          lots: accesses.map(x => x.pk)
        }
        try {
          await this.$api.accessService.postAllotments(data)
        } catch (e) {
          this.loadingAccess = false
          this.selectedAccess = null
        }
      },
      async deleteAllotments (accesses) {
        let data = {allotments: accesses.map(x => x.pk)}
        try {
          await this.$api.accessService.deleteAllotments(data)
        } catch (e) {
          this.loadingAccess = false
          this.selectedAccess = null
        }
      },
      async updateAccess (access) {
        this.loadingAccess = true
        let newAccess = {
          pk: access.pk,
          remuneration: access.remuneration,
          end_date: access.end_date,
          start_date: access.start_date,
          use_company_remuneration: access.use_company_remuneration,
          use_program_remuneration: access.use_program_remuneration
        }
        let r = null
        if (this.panel === 'programAccess') {
          r = await this.$api.accessService.patch(access.pk, access)
        } else {
          r = await this.$api.accessService.patchPromoteurAccess(newAccess.pk, newAccess)
        }
        this.loadingAccess = false
        this.selectedAccess = null
        let index = -1
        if (this.panel === 'programAccess') {
          index = this.programAccesses.findIndex(x => x.pk === newAccess.pk)
          if (index >= 0) this.$set(this.programAccesses, index, r.data)
          else this.reloadAccess()
        } else {
          index = this.promoteurAccesses.findIndex(x => x.pk === newAccess.pk)
          if (index >= 0) this.$set(this.promoteurAccesses, index, r.data)
          else this.reloadAccess()
        }
        this.$notify({
          type: 'is-success',
          text: 'Mandat mis à jour.'
        })
      },
      deleteSelectedAccesses () {
        this.loading = true
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ces mandats (' + this.selectedItems.length + ') ?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.$api.accessService.deleteMany({pk: this.selectedItems}).then(() => {
              this.loading = false
              this.selectedAccess = null
              this.$notify({
                type: 'is-success',
                text: 'Les mandats sont en cours de suppression.'
              })
              this.loadItems()
            }).catch(() => {
              this.loading = false
              this.selectedAccess = null
              this.$notify({
                type: 'is-danger',
                text: 'Erreur lors de la suppression des mandats.'
              })
            })
          }
        })
      },
      deleteAccess (id) {
        this.loadingAccess = true
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce mandat ?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.$api.accessService.delete(id).then(() => {
              this.loadingAccess = false
              this.selectedAccess = null
              this.$notify({
                type: 'is-success',
                text: 'Le mandat est en cours de suppression.'
              })
              let index = this.programAccesses.findIndex(x => x.pk === id)
              if (index >= 0) this.programAccesses.splice(index, 1)
              else this.reloadAccess()
              this.selectedAccess = null
            }).catch(() => {
              this.loadingAccess = false
              this.selectedAccess = null
              this.$notify({
                type: 'is-danger',
                text: 'Erreur lors de la suppression du mandat.'
              })
            })
          }
        })
      },
      deletePromoteurAccess (accessPk) {
        const d = {
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce mandat ?',
          confirmButtonText: 'Supprimer'
        }
        this.$swal(d).then(r => {
          if (r.value) {
            this.$api.accessService.deletePromoteurAccess(accessPk).then(res => {
              if (res) {
                let index = this.promoteurAccesses.findIndex(x => x.pk === accessPk)
                if (index >= 0) this.promoteurAccesses.splice(index, 1)
                else this.reloadAccess()
              }
              this.$notify({
                type: 'is-success',
                text: `Mandat supprimé.`
              })
            })
          }
        })
      },
      async addAccess (access) {
        this.loadingAccess = true
        let data = {
          use_company_remuneration: true,
          promoteurs: [access.promoteur],
          companies: [this.companyPk]
        }
        let res = await this.$api.accessService.postPromoteurAccess(data)
        if (res) {
          this.$notify({
            type: 'is-success',
            text: 'Mandat créé.'
          })
          this.loadingAccess = false
          this.reloadAccess()
        }
      },
      clearMultiselect () {
        this.multiselection = !this.multiselection
        this.clearSelectedItems()
      },
      reloadAccess () {
        this.programAccesses = []
        this.getProgramAccesses()
        if (this.isDistributeurMode) {
          this.promoteurAccesses = []
          this.getPromoteurAccesses()
        }
      },
      createAccess (access) {
        this.$notify({
          type: 'is-info',
          text: 'Création des mandats en cours...'
        })
        this.simulateSubmit = false
        this.loadingAccess = true
        this.$api.accessService.post(access).then(res => {
          this.programPanel = 'programOpenAccess'
          this.loadingAccess = false
          this.selectedAccess = null
          this.reloadAccess()
        }).catch(() => {
          this.loadingAccess = false
          this.selectedAccess = null
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du mandat.'
          })
        })
      },
      askSubmit () {
        this.$refs.accessForm.submit()
      }
    },
    created () {
      this.getProgramAccesses(true)
      if (this.isDistributeurMode) {
        this.promoteurs = this.promoteursList.slice()
        this.getPromoteurAccesses(true)
      } else {
        this.panel = 'programAccess'
      }
    },
    mounted () {
      bus.$on(EVENTS.RELOAD, ({mode}) => {
        if (mode === 'ACCESS') {
          this.reloadAccess()
        }
      })
    },
    destroyed () {
      bus.$off(EVENTS.RELOAD)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/company/CompanyVuePanels/CompanyAccessPanel.vue